
const navigation = {
  home: 'Startseite',
  sugar: 'Zucker',
  coffee: 'Kaffee',
  logistics: 'Logistik',
  news: 'Nachrichten',
  contact: 'Kontakt'
};

const hero = {
  title: 'Rohstoffexporte',
  subtitle: 'Zucker und Kaffee aus Brasilien in die Welt',
  description: 'Brasilien ist Weltmarktführer in der Produktion und dem Export von Zucker und Kaffee. Diese Website bietet einen umfassenden Überblick über diese Produkte, ihre Märkte, Exportlogistik und vieles mehr.',
  exploreSugar: 'Zucker Erkunden',
  discoverCoffee: 'Kaffee Entdecken'
};

const features = {
  title: 'Erkunden Sie Unsere Bereiche',
  description: 'Entdecken Sie detaillierte Informationen über Prozesse, Märkte und Logistik der wichtigsten brasilianischen Rohstoffe',
  sugar: {
    title: 'Lernen Sie den Zuckerexportprozess kennen',
    description: 'Vom Feld zum Hafen: verstehen Sie, wie brasilianischer Zucker internationale Märkte erreicht'
  },
  coffee: {
    title: 'Entdecken Sie die Wege des brasilianischen Kaffees',
    description: 'Tradition und Qualität, die Brasilien zum weltgrößten Kaffeeexporteur machen'
  },
  logistics: {
    title: 'Verstehen Sie Logistik und Frachtschiffe',
    description: 'Die Hafen- und Transportinfrastruktur, die Exporte ermöglicht'
  },
  learnMore: 'Mehr Erfahren'
};

const stats = {
  title: 'Brasilien in Zahlen',
  description: 'Daten, die Brasiliens Bedeutung auf dem Weltmarkt für Rohstoffe demonstrieren',
  sugarExport: 'Des produzierten Zuckers wird exportiert',
  coffeeWorld: 'Des Weltkaffees kommt aus Brasilien',
  mainPorts: 'Hauptexporthäfen',
  countries: 'Zielländer'
};

const cta = {
  title: 'Bleiben Sie Informiert',
  description: 'Verfolgen Sie die neuesten Trends im Rohstoffmarkt und Branchennachrichten',
  seeNews: 'Nachrichten Sehen',
  contact: 'Kontakt Aufnehmen'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'Brasilianischer Zucker',
    subtitle: 'Vom Feld zum Hafen'
  },
  types: {
    title: 'Arten von Exportiertem Zucker',
    vhp: {
      name: 'VHP (Very High Polarization)',
      description: 'Rohzucker mit hoher Polarisation, ideal für Raffination'
    },
    refined: {
      name: 'Raffiniert',
      description: 'Weißer raffinierter Zucker, konsumfertig'
    },
    crystal: {
      name: 'Kristall',
      description: 'Kristallisierter Zucker, häufiger auf dem Inlandsmarkt'
    }
  },
  regions: {
    title: 'Hauptproduktionsregionen',
    sp: {
      name: 'São Paulo',
      production: '55%',
      description: 'Größte Produktionsregion des Landes'
    },
    mg: {
      name: 'Minas Gerais',
      production: '12%',
      description: 'Zweitgrößte Produktionsregion'
    },
    go: {
      name: 'Goiás',
      production: '10%',
      description: 'Wichtige Region im Zentral-Westen'
    }
  },
  process: {
    title: 'Exportprozess',
    step1: {
      title: 'Zuckerrohrernte',
      description: 'Mechanisierte oder manuelle Rohrernte'
    },
    step2: {
      title: 'Verarbeitung in Zuckermühlen',
      description: 'Mahlen und Extraktion von Rohrsaft'
    },
    step3: {
      title: 'Lagerung und Transport',
      description: 'Lagerung in Silos und Straßentransport'
    },
    step4: {
      title: 'Hafenverladung',
      description: 'Beladung auf Schüttgutfrachter'
    }
  },
  market: {
    title: 'Internationaler Markt',
    destinations: 'Hauptziele',
    factors: {
      title: 'Preisbeeinflussende Faktoren',
      climate: {
        title: 'Klimabedingungen:',
        description: 'Dürren oder übermäßige Regenfälle beeinträchtigen die Produktion'
      },
      oil: {
        title: 'Ölpreis:',
        description: 'Beeinflusst die Ethanolproduktion als Alternative'
      },
      demand: {
        title: 'Weltweite Nachfrage:',
        description: 'Bevölkerungswachstum und Konsumveränderungen'
      },
      exchange: {
        title: 'Wechselkurs:',
        description: 'Dollarschwankungen beeinflussen die Wettbewerbsfähigkeit'
      }
    }
  },
  curiosities: {
    title: 'Fakten über Brasilianischen Zucker',
    exported: 'Der brasilianischen Produktion wird exportiert',
    worldShare: 'Des Weltzuckers kommt aus Brasilien',
    mills: 'Mühlen in Betrieb im Land',
    hectares: 'Hektar Zuckerrohr gepflanzt',
    worldRank: 'Platz in der Weltproduktion',
    countries: 'Länder importieren unseren Zucker'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'Brasilianischer Kaffee',
    subtitle: 'Tradition und Weltqualität'
  },
  history: {
    title: 'Geschichte und Wirtschaftliche Bedeutung',
    worldProduction: 'Weltproduktion',
    jobs: 'Geschaffene Arbeitsplätze',
    exports: 'Jährliche Exporte',
    importers: 'Importierende Länder'
  },
  types: {
    title: 'Arten von Exportiertem Kaffee',
    arabica: {
      name: 'Arabica',
      percentage: '75%',
      description: 'Hochwertiger Kaffee, milder und aromatischer Geschmack',
      regions: 'Minas Gerais, São Paulo, Espírito Santo'
    },
    robusta: {
      name: 'Robusta (Conilon)',
      percentage: '25%',
      description: 'Widerstandsfähigerer Kaffee, starker Geschmack und höherer Koffeingehalt',
      regions: 'Espírito Santo, Rondônia, Bahia'
    }
  },
  states: {
    title: 'Produzierende Bundesstaaten',
    mg: {
      name: 'Minas Gerais',
      production: '54%',
      specialty: 'Berg-Arabica'
    },
    es: {
      name: 'Espírito Santo',
      production: '23%',
      specialty: 'Conilon und Arabica'
    },
    sp: {
      name: 'São Paulo',
      production: '9%',
      specialty: 'Traditioneller Arabica'
    },
    ba: {
      name: 'Bahia',
      production: '8%',
      specialty: 'Conilon und Spezialkaffees'
    }
  },
  process: {
    title: 'Exportprozess',
    step1: {
      title: 'Ernte',
      description: 'Manuell (derriça) oder mechanisch'
    },
    step2: {
      title: 'Trocknung',
      description: 'Natürlich auf Terrassen oder künstlich'
    },
    step3: {
      title: 'Verarbeitung',
      description: 'Schälung und Klassifizierung'
    },
    step4: {
      title: 'Lagerung',
      description: 'In Säcken oder Containern'
    },
    step5: {
      title: 'Export',
      description: 'Hafenverschiffung'
    }
  },
  market: {
    title: 'Ziele und Globaler Konsum',
    destinations: 'Hauptziele',
    factors: {
      title: 'Marktfaktoren',
      quotes: {
        title: 'Internationale Notierungen:',
        description: 'Börsen in New York und London bestimmen Preise'
      },
      climate: {
        title: 'Klimabedingungen:',
        description: 'Frost und Dürren beeinflussen Preise erheblich'
      },
      quality: {
        title: 'Qualität:',
        description: 'Spezialkaffees erzielen Premium-Preise'
      },
      logistics: {
        title: 'Logistik:',
        description: 'Transportkosten beeinflussen Wettbewerbsfähigkeit'
      }
    }
  },
  trends: {
    title: 'Markttrends',
    specialty: {
      title: 'Spezialkaffees',
      description: 'Wachsende Nachfrage nach Single-Origin-Kaffees und speziellen Zubereitungsmethoden'
    },
    certifications: {
      title: 'Zertifizierungen',
      description: 'Bio-, Fair Trade- und Rainforest Alliance-Zertifizierungen'
    },
    sustainability: {
      title: 'Nachhaltigkeit',
      description: 'Umweltverantwortliche und sozial gerechte Praktiken'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: 'Logistik und Transport',
    subtitle: 'Die Infrastruktur Hinter den Exporten'
  },
  ships: {
    title: 'Arten von Frachtschiffen',
    bulk: {
      name: 'Schüttgutfrachter (Bulk Carriers)',
      description: 'Schiffe spezialisiert auf Transport von Schüttgütern wie Zucker',
      capacity: '60.000 - 200.000 Tonnen'
    },
    containers: {
      name: 'Trockencontainer',
      description: 'Transport von Kaffee in Säcken und verpackten Produkten',
      capacity: '1.000 - 20.000 TEU'
    },
    refrigerated: {
      name: 'Kühlcontainer',
      description: 'Für Produkte, die Temperaturkontrolle benötigen',
      capacity: '200 - 2.000 TEU'
    }
  },
  ports: {
    title: 'Hauptexporthäfen',
    santos: {
      name: 'Hafen Santos (SP)',
      description: 'Größter Hafen Lateinamerikas',
      products: 'Zucker, Kaffee, Soja',
      capacity: '4,8 Millionen TEU/Jahr'
    },
    paranagua: {
      name: 'Hafen Paranaguá (PR)',
      description: 'Hauptexportkorridor des Südens',
      products: 'Zucker, Soja, Mais',
      capacity: '1,2 Millionen TEU/Jahr'
    },
    vitoria: {
      name: 'Hafen Vitória (ES)',
      description: 'Wichtig für Erz und Kaffee',
      products: 'Kaffee, Zucker, Erz',
      capacity: '800 Tausend TEU/Jahr'
    },
    itaqui: {
      name: 'Hafen Itaqui (MA)',
      description: 'Tor zum Nordosten',
      products: 'Zucker, Soja, Mais',
      capacity: '600 Tausend TEU/Jahr'
    }
  },
  storage: {
    title: 'Lagerhäuser und Depots',
    silos: {
      name: 'Schüttgutsilos',
      description: 'Vertikale Lagerung für Schüttzucker',
      capacity: '10.000 - 100.000 Tonnen'
    },
    warehouses: {
      name: 'Zolllager',
      description: 'Lagerhäuser für auf Export wartende Produkte',
      capacity: '5.000 - 50.000 Tonnen'
    },
    refrigerated: {
      name: 'Kühllager',
      description: 'Konservierung temperaturempfindlicher Produkte',
      capacity: '1.000 - 20.000 Tonnen'
    }
  },
  transport: {
    title: 'Inlandstransport',
    modes: 'Transportarten',
    road: {
      name: 'Straße',
      percentage: '70%',
      description: 'Hauptverkehrsträger für Inlandstransport'
    },
    rail: {
      name: 'Schiene',
      percentage: '25%',
      description: 'Wachsende Nutzung in einigen Regionen'
    },
    waterway: {
      name: 'Wasserweg',
      percentage: '5%',
      description: 'In spezifischen Regionen verwendet'
    },
    characteristics: {
      title: 'Transportmerkmale',
      distances: {
        title: 'Durchschnittsentfernungen',
        farm: 'Farm → Lager: 50-200 km',
        warehouse: 'Lager → Hafen: 200-800 km',
        time: 'Durchschnittszeit: 2-5 Tage'
      },
      costs: {
        title: 'Logistikkosten',
        percent: 'Repräsentieren 15-25% des Endpreises',
        fuel: 'Kraftstoff: größter Bestandteil',
        tolls: 'Maut und Hafengebühren'
      },
      seasonality: {
        title: 'Saisonalität',
        peak: 'Spitze während der Ernte (Mai-Sep)',
        demand: 'Höhere Transportnachfrage',
        increase: 'Frachtratensteigerung'
      }
    }
  },
  challenges: {
    title: 'Herausforderungen und Chancen',
    infrastructure: {
      title: 'Hafeninfrastruktur',
      description: 'Bedarf an Modernisierung und Kapazitätserweiterung'
    },
    costs: {
      title: 'Logistikkosten',
      description: 'Reduzierung von Transport- und Lagerkosten'
    },
    sustainability: {
      title: 'Nachhaltigkeit',
      description: 'Umsetzung umweltverantwortlicher Praktiken'
    },
    digitalization: {
      title: 'Digitalisierung',
      description: 'Automatisierung und digitale Prozesskontrolle'
    }
  },
  numbers: {
    title: 'Logistikzahlen',
    tonnage: 'Tonnen umgeschlagen/Jahr',
    ports: 'Organisierte Häfen',
    terminals: 'Private Terminals',
    gdp: 'Logistikkosten des BIP'
  }
};

// News page translations
const news = {
  hero: {
    title: 'Nachrichten und Trends',
    subtitle: 'Was Passiert auf dem Exportmarkt?'
  },
  market: {
    title: 'Echtzeit-Notierungen'
  },
  tabs: {
    recent: 'Aktuelle Nachrichten',
    analysis: 'Analysen',
    forecasts: 'Prognosen'
  },
  analysis: {
    title: 'Marktanalyse',
    positive: {
      title: 'Positive Faktoren',
      climate: 'Günstiges Klima für nächste Ernte',
      demand: 'Wachsende internationale Nachfrage',
      infrastructure: 'Verbesserungen der Logistikinfrastruktur'
    },
    challenges: {
      title: 'Herausforderungen',
      exchange: 'Wechselkursvolatilität',
      competition: 'Internationale Konkurrenz',
      costs: 'Hohe Logistikkosten'
    }
  },
  newsletter: {
    title: 'Bleiben Sie Informiert',
    description: 'Erhalten Sie wöchentliche Updates über den Rohstoffmarkt direkt in Ihre E-Mail',
    placeholder: 'Ihre E-Mail',
    subscribe: 'Abonnieren'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'Über das Projekt',
    subtitle: 'Lernen Sie unser Team kennen und kontaktieren Sie uns'
  },
  about: {
    title: 'Wer Wir Sind'
  },
  objectives: {
    title: 'Unsere Ziele',
    educational: {
      title: 'Bildend',
      description: 'Aufklärung über Produktions- und Exportprozesse der wichtigsten brasilianischen Rohstoffe'
    },
    informative: {
      title: 'Informativ',
      description: 'Bereitstellung aktueller Daten über Märkte, Preise und Branchentrends'
    },
    connective: {
      title: 'Verbindend',
      description: 'Verbindung verschiedener am brasilianischen Agribusiness interessierter Zielgruppen'
    }
  },
  team: {
    title: 'Unser Team'
  },
  sources: {
    title: 'Datenquellen',
    description: 'Wir verwenden ausschließlich offizielle Daten anerkannter Institutionen, um Genauigkeit und Zuverlässigkeit der präsentierten Informationen zu gewährleisten.'
  },
  form: {
    title: 'Kontaktieren Sie Uns',
    subtitle: 'Haben Sie Fragen, Vorschläge oder möchten Sie beitragen? Sprechen Sie mit uns!',
    name: 'Vollständiger Name',
    email: 'E-Mail',
    subject: 'Betreff',
    message: 'Nachricht',
    send: 'Nachricht Senden',
    sending: 'Wird gesendet...',
    success: 'Nachricht erfolgreich gesendet! Wir werden Sie bald kontaktieren.',
    error: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.',
    selectSubject: 'Betreff auswählen',
    subjects: {
      doubt: 'Frage zu Daten',
      suggestion: 'Verbesserungsvorschlag',
      contribution: 'Datenbeitrag',
      partnership: 'Partnerschaftsvorschlag',
      press: 'Presse',
      other: 'Andere'
    },
    placeholder: {
      name: 'Ihr vollständiger Name',
      email: 'ihre@email.com',
      message: 'Beschreiben Sie Ihre Nachricht (maximal 500 Zeichen)'
    },
    charRemaining: 'Zeichen übrig'
  },
  social: {
    title: 'Folgen Sie Uns',
    description: 'Folgen Sie uns in sozialen Medien für die neuesten Updates über den Rohstoffmarkt'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
